/**
 * Editor choices for the reserved string custom field. The generated API exposes
 * customFields as a dictionary; these are UI choices, not a replacement API DTO.
 */
export const propertyLandAccessOptions = [
  'DIRT',
  'SAND',
  'ASPHALT',
  'GRAVEL',
  'OTHER',
] as const;
